var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"whitespace-no-wrap",class:{'px-6 py-4': !_vm.noPadding}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }